const fields = [
  'average_total_in_cents_between',
  'lifetime_total_in_cents_between',
  'year_to_date_total_in_cents_between'
];

export default (field) => {
  return fields.includes(field);
}
